import { isHealthRelatedStudentType, UserData } from "../constants/GlobalTypesAndEnumsAndConstants";

// Accounts the feature is already open for, as it will be for everyone once it
// opens (Elite, or the one free trial station). They are not admins, so the
// owner can test what an ordinary user gets (owner, 2026-09-30). Mirrors
// CLINICAL_EXAM_PRACTICE_EARLY_ACCESS_USER_IDS in the backend's
// routes/voice_clinical_exam_routes.py and in the worker's livekit-routes.ts;
// an id that is only here gets screens whose every request is refused.
const CLINICAL_EXAM_PRACTICE_EARLY_ACCESS_USER_IDS: ReadonlySet<string> = new Set([
  "fJ3dZIx861WVIFWVWL8mBWcgdJC2", // the owner's free test account
  "98HsXgKuOdPgoU6fMI9AlgVmXw82", // Jordyn, a creator (owner, 2026-10-04)
]);

// Clinical exam practice is open to health students (owner, 2026-10-05: the
// learners a clinical examination is for; HEALTH_RELATED_STUDENT_TYPES, the
// student type chosen at sign-up), to admins, and to the early access
// accounts. It shipped switched off for everyone else (owner's rule,
// 2026-09-29) and stays so until the owner opens it further. The build flag is
// the switch; the check on the user is what keeps a switched-on build to those
// learners. The backend and the worker refuse everyone else on their own, so
// changing only this file opens nothing.
//
// Opening it to everyone means removing the check on the user here and setting
// CLINICAL_EXAM_PRACTICE_IS_OPEN_TO_ALL_USERS in the backend's
// routes/voice_clinical_exam_routes.py and the worker's livekit-routes.ts,
// together.
export function isClinicalExamPracticeEnabledForUser(
  user: UserData | null | undefined,
  configuredValue: string | undefined = import.meta.env.REACT_APP_CLINICAL_EXAM_PRACTICE_ENABLED
): boolean {
  const isPracticeFlagEnabled = configuredValue === "true";
  const isUserAdmin = user?.role === "admin";
  const hasEarlyAccess = typeof user?.id === "string" && CLINICAL_EXAM_PRACTICE_EARLY_ACCESS_USER_IDS.has(user.id);
  const isHealthStudent = isHealthRelatedStudentType(user?.student_type);
  return isPracticeFlagEnabled && (isUserAdmin || hasEarlyAccess || isHealthStudent);
}
